var map = {
	"./brown_2-6.png": "./src/assets/brown_2-6.png",
	"./green_2-6.png": "./src/assets/green_2-6.png",
	"./grey_2-6.png": "./src/assets/grey_2-6.png",
	"./red_2-6.png": "./src/assets/red_2-6.png",
	"./yellow_2-6.png": "./src/assets/yellow_2-6.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*_2\\-6\\.png$";